(() => {
  const containerSelector = '[data-terms-consent]';

  const getElements = (container) => ({
    checkbox: container.querySelector('[data-terms-checkbox]'),
    checkout: container.querySelector('[data-terms-checkout]'),
    error: container.querySelector('[data-terms-error]'),
  });

  const syncConsent = (container, showError = false) => {
    const { checkbox, checkout, error } = getElements(container);
    if (!checkbox || !checkout) return false;

    const accepted = checkbox.checked;
    checkout.classList.toggle('is-disabled', !accepted);
    checkout.setAttribute('aria-disabled', String(!accepted));

    if (error) {
      error.hidden = accepted || !showError;
    }

    return accepted;
  };

  const showConsentError = (container) => {
    const { checkbox } = getElements(container);
    syncConsent(container, true);
    checkbox?.focus();
  };

  const initializeConsent = (container) => {
    if (container.dataset.termsInitialized === 'true') return;

    const { checkbox } = getElements(container);
    if (!checkbox) return;

    container.dataset.termsInitialized = 'true';
    checkbox.addEventListener('change', () => syncConsent(container));
    syncConsent(container);
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll(containerSelector).forEach(initializeConsent);
  };

  document.addEventListener(
    'click',
    (event) => {
      const checkout = event.target.closest('[data-terms-checkout]');
      if (!checkout) return;

      const container = checkout.closest(containerSelector);
      if (!container || syncConsent(container)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      showConsentError(container);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const formId = event.target.id;
      if (!formId) return;

      const containers = Array.from(document.querySelectorAll(containerSelector));
      const container = containers.find((item) => item.dataset.termsForm === formId);
      if (!container || syncConsent(container)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      showConsentError(container);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  new MutationObserver(() => initializeAll()).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
